import * as accountsApi from '@/network/api/accounts.api.js'
import * as transfersApi from '@/network/api/internationalTransfers.api.js'
import * as customersApi from '@/network/api/customers/customers.api.js'
import * as favoritesApi from '@/network/api/favorites.api.js'

/** Request Unmasked Customer Info
@return {promise} - Unmasked Customer Info request
*/
export const getClientInfoWithoutMasks = async (context, payload) => {
    const res = await customersApi.getClientInfoWithoutMasks(payload)
    if (res) {
        const data = res.data.data
        context.commit('SAVE_CUSTOMER_INFO', data)
    }
    return res
}

/** requests Accounts Balance
@return {promise} - Accounts Balance request
*/
export const requestAccountsBalances = async (context, payload) => {
    const res = await accountsApi.requestAccountsBalances(payload)
    if (res) {
        const data = res.data.data
        context.commit('SAVE_ACCOUNTS_BALANCES', data)
    }
    return res
}

/** Check if the client meets all prerequisites
@return {promise} - Client prerequisites status
*/
export const requestClientPrerequisites = async (context, payload) => {
    const res = await transfersApi.validateClientForOPE(payload)
    return res
}

/** requests Account Plafond
@return {promise} - Account Plafond request
*/
export const requestAccountPlafond = async (context, payload) => {
    const res = await transfersApi.getAccountPlafond(payload)
    if (res) {
        const data = res.data.data
        context.commit('SAVE_ACCOUNT_PLAFOND', data)
    }
    return res
}

/** requests Customer Limits
@return {promise} - Customer Limits request
*/
export const requestCustomerLimits = async (context, payload) => {
    const res = await transfersApi.getCustomerLimits(payload)
    if (res) {
        const data = res.data.data
        context.commit('SAVE_CUSTOMER_LIMITS', data.internationalTransferGetCustomerLimits)
    }
    return res
}

/** Request Transfer Currencies
@return {promise} - Transfer Currencies request
*/
export const requestTransferCurrencies = async (context, payload) => {
    const res = await transfersApi.requestInternationalTransfersCurrenciesList(payload)
    if (res) {
        const data = res.data.data
        context.commit('SAVE_TRANSFER_CURRENCIES', data.internationalTransferCurrencies)
    }
    return res
}

/** requests Countries List
@return {promise} - Countries List request
*/
export const requestCountriesList = async (context, payload) => {
    const res = await transfersApi.getCountriesList(payload)
    if (res) {
        const data = res.data.data
        context.commit('SAVE_COUNTRIES_LIST', data.internationalTransferCountries)
    }
    return res
}

/** Request Transfer Reasons
@return {promise} - Transfer Reasons request
*/
export const requestTransferReasons = async (context, payload) => {
    const res = await transfersApi.getReasonsList(payload)
    if (res) {
        const data = res.data.data
        context.commit('SAVE_TRANSFER_REASONS', data.internationalTransferReasonView)
        context.commit('SAVE_TRANSFER_OOPERATIONS_TYPES')
        context.commit('SAVE_TRANSFER_CATEGORIES')
        context.commit('SAVE_TRANSFER_PAYMENT_TYPES')
    }
    return res
}

/** Request operation types depending on reason selected
@return {promise} - Operation types depending on reason selected request
*/
export const requestTransferOperationTypes = async (context, payload) => {
    const res = await transfersApi.getReasonsList({ parentInternationalTransferReasonId: payload.purposeId })
    if (res) {
        const data = res.data.data
        context.commit('SAVE_TRANSFER_OOPERATIONS_TYPES', data.internationalTransferReasonView)
        context.commit('SAVE_TRANSFER_CATEGORIES')
        context.commit('SAVE_TRANSFER_PAYMENT_TYPES')
    }
    return res
}

/** Request categories depending on operation type selected
@return {promise} - Categories depending on operation type selected request
*/
export const requestTransferCategories = async (context, payload) => {
    const res = await transfersApi.getReasonsList({ parentInternationalTransferReasonId: payload.operationTypeId })
    if (res) {
        const data = res.data.data
        context.commit('SAVE_TRANSFER_CATEGORIES', data.internationalTransferReasonView)
        context.commit('SAVE_TRANSFER_PAYMENT_TYPES')
    }
    return res
}

/** Payments types depending on operation category
@return {promise} - Types depending on operation category request
*/
export const requestTransferCategoriesPaymentTypes = async (context, payload) => {
    const res = await transfersApi.getReasonsList({ rootInternationalTransferReasonId: payload.rootInternationalTransferReasonId })
    if (res) {
        const data = res.data.data
        context.commit('SAVE_TRANSFER_PAYMENT_TYPES', data.internationalTransferPaymentTypes)
    }
    return res
}

/** Transfer Reasons
@return {promise} - Transfer Reasons
*/
export const requestTransfersExpenses = async (context, payload) => {
    const res = await transfersApi.getExpensesList(payload)
    if (res) {
        const data = res.data.data
        context.commit('SAVE_TRANSFER_EXPENSES', data.internationalTransferExpenses)
    }
    return res
}

/** Request Calculated Transfer Expense
@return {promise} - Calculated Transfer Expense
*/
export const calcEstimatedAmount = async (context, payload) => {
    const res = await transfersApi.requestTMXEstimatedAmount(payload)
    return res
}

/** Request Iban Details
@return {promise} - Iban Details
*/
export const requestIbanDetails = async (context, payload) => {
    const res = await transfersApi.getIBANDetails(payload)
    return res
}

/** Request Transfer Details
@return {promise} - Transfer Details
*/
export const requestTransferDetail = async (context, payload) => {
    const res = await transfersApi.requestTransferDetail(payload)
    return res
}

/** Request Swift Details
@return {promise} - Swift Details
*/
export const requestSwiftDetails = async (context, payload) => {
    const res = await transfersApi.requestSwiftDetails(payload)
    return res
}

/** Request International Transfer
@return { promise } - Create International Transfer
*/
export const requestInternationalTransfer = async (context, payload) => {
    const res = await transfersApi.createPontualTransfer(payload)

    return res
}

/** Request International Transfers Requests List
@return { promise } - Create International Transfers Requests List
*/
export const requestInternationalTransfersRequestsList = async (context, payload) => {
    const res = await transfersApi.requestInternationalTransfersRequestsList(payload)

    if (res) {
        const data = res.data.data
        context.commit('SAVE_TRANSFERS_LIST', { pageNumber: payload.pageNumber, data: data })
    }

    return res
}

/** requests Favorites List
@return {promise} - Favorite List request
*/
export const requestFavoritesList = async (context, payload) => {
    const res = await favoritesApi.getFavoritesList(payload)
    if (res) {
        const data = res.data.data
        context.commit('SAVE_FAVORITES', { pageNumber: payload.pageNumber, data: data })
    }
    return res
}

/* ***********************************************
*                   CLEAR ACTIONS                *
*********************************************** */
export const clearFeatureStates = async (context, payload) => {
    context.commit('CLEAR_FEATURE_STATE')
}
